import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IProFormaData } from 'views/ProFormaTable/types';

interface ICreateProFormaFromSensitivityProps {
    dealId: number;
    proFormaId: number;
    parameters: {
        exit_cap_rate?: number;
        hard_soft_costs?: number;
        gross_rent?: number;
        vacancy_rate?: number;
        lease_up_pace?: number;
        operating_expenses?: number;
        interest_rate?: number;
        ltc?: number;
        source_id?: number;
    };
    organizationId: string;
}

const createProFormaFromSensitivity = async ({
    dealId,
    proFormaId,
    parameters,
    organizationId,
}: ICreateProFormaFromSensitivityProps): Promise<IProFormaData> => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.PRO_FORMA_SENSITIVITY_ANALYSIS_CREATE(organizationId, proFormaId),
        parameters,
    );
    return response.data;
};

const useCreateProFormaFromSensitivity = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createProFormaFromSensitivity,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getProFormas'] });
        },
    });
};

export default useCreateProFormaFromSensitivity;
